import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App/index.vue'
import router from './router'
import { setupNaive } from './plugins/naive'
import { setupElement } from './plugins/element'
import './styles/global.scss'

const app = createApp(App)
app.use(createPinia())
app.use(router)
setupElement(app)
setupNaive(app)
app.mount('#app')
